module.exports = __webpack_public_path__ + "assets/img/title-3feed568.png";